import { useEffect, useState } from "react";
import { Megaphone, FlaskConical, Coins, Users } from "lucide-react";

const STAGES = [
  { id: "canvass", label: "Canvass", sub: "Advocacy", icon: Megaphone },
  { id: "plan", label: "Plan", sub: "Research", icon: FlaskConical },
  { id: "fund", label: "Fund", sub: "Opportunity", icon: Coins },
  { id: "grow", label: "Grow", sub: "Community", icon: Users },
];

const JourneyNav = () => {
  const [active, setActive] = useState<string>("canvass");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible[0]) setActive(visible[0].target.id);
      },
      { rootMargin: "-40% 0px -50% 0px", threshold: [0, 0.2, 0.5, 1] }
    );
    STAGES.forEach((s) => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const handleClick = (e: React.MouseEvent, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 88;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div className="sticky top-16 z-30 bg-background/85 backdrop-blur border-y border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-stretch overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {STAGES.map((s, i) => {
            const isActive = active === s.id;
            return (
              <a
                key={s.id}
                href={`#${s.id}`}
                onClick={(e) => handleClick(e, s.id)}
                className={`group flex-1 min-w-[140px] flex items-center gap-3 py-4 px-3 md:px-5 border-b-2 transition-colors ${
                  isActive
                    ? "border-primary text-foreground"
                    : "border-transparent text-muted-foreground hover:text-foreground"
                }`}
              >
                <span
                  aria-hidden="true"
                  className={`font-display text-sm font-bold ${
                    isActive ? "text-primary" : "text-muted-foreground"
                  }`}
                >
                  0{i + 1}
                </span>
                <s.icon
                  className={`h-4 w-4 shrink-0 ${isActive ? "text-primary" : ""}`}
                />
                <div className="min-w-0">
                  <div className="font-display text-sm font-semibold leading-tight">
                    {s.label}
                  </div>
                  <div className="text-[10px] uppercase tracking-wider text-muted-foreground leading-tight">
                    {s.sub}
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default JourneyNav;